import { InactiveAccounts } from "~/types/equipment"

/**
 * Get CSS color class for processing status
 * @param status - Processing status
 * @returns CSS color class name
 */
export function getProcessingStatusColorClass(status: InactiveAccounts.ProcessingStatus): string {
  const colorMap: Record<InactiveAccounts.ProcessingStatus, string> = {
    APPROVED: 'green',
    COMMUNICATION_SENT: 'blue',
    FINISHED: 'gray',
    PENDING_APPROVAL: 'yellow',
    REJECTED: 'red',
  };
  return colorMap[status] || 'gray';
}

/**
 * Get display label for processing status
 * @param status - Processing status
 * @returns Localized status label
 */
export function getProcessingStatusLabel(status: InactiveAccounts.ProcessingStatus): string {
  const labelMap: Record<InactiveAccounts.ProcessingStatus, string> = {
    APPROVED: 'Aprovado',
    COMMUNICATION_SENT: 'Comunicação Enviada',
    FINISHED: 'Finalizado',
    PENDING_APPROVAL: 'Pendente Aprovação',
    REJECTED: 'Rejeitado',
  };
  return labelMap[status] || status;
}

/**
 * Get CSS color class for Solfacil status
 * @param status - Solfacil status
 * @returns CSS color class name
 */
export function getSolfacilStatusColorClass(status: InactiveAccounts.StatusSolfacil): string {
  const colorMap: Record<InactiveAccounts.StatusSolfacil, string> = {
    BLOCKED: 'red',
    REGULAR: 'green',
  };
  return colorMap[status] || 'gray';
}

/**
 * Get display label for Solfacil status
 * @param status - Solfacil status
 * @returns Localized status label
 */
export function getSolfacilStatusLabel(status: InactiveAccounts.StatusSolfacil): string {
  const labelMap: Record<InactiveAccounts.StatusSolfacil, string> = {
    BLOCKED: 'Bloqueado',
    REGULAR: 'Regular',
  };
  return labelMap[status] || status;
}
